import type { OfferAdditionalOptionsInner } from '~/api/pricing-offers'
import { useOfferStore } from '~/stores/offer'

export function useOfferAdditionalOptions(tag: string, longDescriptionSeparator: string = '\n', alternativeTag?: string) {
  const option = computed<OfferAdditionalOptionsInner | undefined>(() => {
    const options = useOfferStore().selectedOffer?.additionalOptions
    return findAdditionalOptions(options, tag) ?? findAdditionalOptions(options, alternativeTag)
  })

  const longDescription = computed<string[]>(() => option.value ? option.value.longDescription!.split(longDescriptionSeparator) : [])

  const shortDescription = computed<string>(() => option.value?.description
    ?? longDescription.value[0].substring(1).split(':')[1],
  )

  return {
    option,
    longDescription,
    shortDescription,
  }
}

function findAdditionalOptions(options?: OfferAdditionalOptionsInner[], tag?: string): OfferAdditionalOptionsInner | undefined {
  return tag
    ? options?.find((property: OfferAdditionalOptionsInner) => property?.tags?.includes(tag))
    : undefined
}
